export default {
  notificationData: {
    show: false,
    message: '',
    type: ''
  },
  confirm: {
    show: false,
    title: '',
    message: '',
    callback: null
  },
  loading: {
    count: 0
  }
}
